module.exports = __webpack_public_path__ + "static/rank_title.7d49cca6.png";